const About = () => {
  return (
    <div className="hover:border-2 w-96 h-96 flex  flex-col ml-10 justify-center hover:border-slate-950 hover:cursor-pointer  mt-32 rounded-lg shadow-sm bg-[#f9f9f9] ">
      <div className="flex items-center justify-center">
        <img
          src="https://avatars.githubusercontent.com/u/95128645?s=400&u=9eadfcfc8392a81b884bc84cc9d67ef85137db4f&v=4"
          alt="menu-item"
          className="py-2 px-1 rounded-full opacity-95  w-32 h-32"
        />
      </div>

      <div className="flex flex-col items-center justify-center g">
        <h3 className="text-decor font-bold mx-1">Prince Kr. MIshra</h3>
        {/* <p className="text-decor  text-gray-700 mx-1 ">{cusion.join(",")}</p> */}
        <p className="text-decor text-gray-700 mx-1">React developer</p>

        <p className="text-decor right-0 text-gray-700 mx-1 ">
          Built for personal
        </p>
        <p className="text-decor right-0 text-gray-700 mx-1 ">
          Inspired by Swigy
        </p>
      </div>
    </div>
  );
};

export default About;
